import React from "react";
import { InfoTooltip } from "../../../../data-display/InfoTooltip/InfoTooltip";
import { useDataMan } from "../../hooks/useDataMan";
import { useDataManColumn } from "../../hooks/useDataManColumn";
import { DataManSelectAllControl } from "./DataManSelectAllControl";

export const DataManHeaderColumnContent: React.FC = () => {
  const { column, isActionColumn, isSelectionColumn, isSortableHandler } =
    useDataManColumn();
  const { visibleColumns, hasBulkSelection } = useDataMan();

  // When a selection checkbox precedes the columns, the first data column drops
  // its left padding so it sits flush against the checkbox cell (no extra gap).
  const dropLeftPad =
    hasBulkSelection && !!column && visibleColumns?.[0]?.key === column.key;

  // Different wrapper classes for different column types
  const wrapperClass = isSelectionColumn
    ? "flex items-center justify-start pl-4"
    : dropLeftPad
      ? "flex items-center justify-between pr-4"
      : "flex items-center justify-between px-4";

  return (
    <div className={wrapperClass}>
      <div>
        {isActionColumn ? (
          <>&nbsp;</>
        ) : isSelectionColumn ? (
          <DataManSelectAllControl />
        ) : isSortableHandler ? (
          <>&nbsp;</>
        ) : (
          <h3 className="flex items-center pl-0.5 font-inter font-semibold text-content-muted text-section-label uppercase tracking-[0.04em]">
            {column?.title || ""}
            {column?.info && (
              <InfoTooltip size="sm">
                <span className="font-normal normal-case tracking-normal">
                  {column.info}
                </span>
              </InfoTooltip>
            )}
          </h3>
        )}
      </div>
    </div>
  );
};
